import React from 'react';
import moment from 'moment';

import Create from '../common/views/Create';
import SimpleForm from '../common/forms/SimpleForm';
import InvoiceForm from './InvoiceForm';

const defaultValues = {
	supplier_name: '',
	supplier_street: '',
	supplier_zipcode: '',
	supplier_city: '',
	supplier_country: '',
	supplier_vat_number: '',
	bank_iban: '',
	bank_bic: '',
	number: '',
	purchase_order: '',
	invoiced_at: moment().format('YYYY-MM-DD'),
	due_date: moment().format('YYYY-MM-DD'),
	terms: '',
	notes: ''
};

const InvoiceCreate = (props) => (
	<Create {...props}>
		<SimpleForm defaultValues={defaultValues}>
			<InvoiceForm />
		</SimpleForm>
	</Create>
);

export default InvoiceCreate;